/*
 * @Author: gaobin
 * @Date: 2025-05-19 16:50:42
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-05-23 18:54:39
 * @Description: 使用全局加载动画
 */
import { ref } from 'vue';

const globalLoadingState = ref(false);

// 遮罩透明度
const overlayOpacity1 = ref(0);
// 加载动画背景透明度
const overlayOpacity2 = ref(0); // UI: 0.1/0.7

// 加载中页面 顶部是否有标题tab
// const isHasTopBar = ref(true);

// 加载动画顶部距离
const loadingTop = ref(0);

export function useLoading() {
  function showLoading() {
    console.log('showLoading');
    globalLoadingState.value = true;
  }

  function hideLoading() {
    console.log('hideLoading');
    globalLoadingState.value = false;
  }

  // 设置加载中页面 顶部tab有无的情况
  // function setIsHasTopBar(Bol) {
  //   isHasTopBar.value = Bol;
  // }

  // 设置遮罩层透明度
  function setMaskOpacity(opacity) {
    overlayOpacity1.value = opacity;
  }

  // 设置加载动画背景透明度
  function setLoadingOpacity(opacity) {
    overlayOpacity2.value = opacity;
  }

  // 设置加载动画顶部距离
  function setLoadingTop(top) {
    loadingTop.value = top;
  }

  return {
    globalLoadingState,
    showLoading,
    hideLoading,
    // setIsHasTopBar,
    overlayOpacity1,
    overlayOpacity2,
    // isHasTopBar,
    setMaskOpacity,
    setLoadingOpacity,
    loadingTop,
    setLoadingTop,
  };
}
